import './TextPurple.scss';

const TextPurple = (chunks: string): JSX.Element => (
	<span className="text-purple">
		{chunks}
	</span>
);

export default TextPurple;
